/**
 * URL base do servidor Socket.IO (HTTP/S — o cliente socket.io usa o mesmo host da API).
 * Prioridade: REACT_APP_WS_URL > hostname da página + porta da API > localhost.
 */
export function getSocketBaseUrl() {
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const port = process.env.REACT_APP_API_PORT || '3001';
    return `http://${window.location.hostname}:${port}`;
  }
  return 'http://localhost:3001';
}
